import type { IModulesNavigationPlatform } from 'core/model/interfaces/module-navigation.interface';
import { moduleNavigationData } from './module-navigation.data';
import { transformModuleNavigation } from './module-navigation.mapper';

export const moduleNavigationService = {
  getModulesNavigation: async (): Promise<Array<IModulesNavigationPlatform>> => {
    const data = await moduleNavigationData.getModulesNavigation();
    return transformModuleNavigation(data);
  },
};
